import React from 'react';
import type { CmsBlock } from '../../types';
import {
  Plus,
  Heading,
  AlignLeft,
  Image as ImageIcon,
  List,
  AlertCircle,
  Table as TableIcon,
  Minus,
  Code,
  Columns as ColumnsIcon,
} from 'lucide-react';

interface BlockToolbarProps {
  onAddBlock: (type: CmsBlock['type']) => void;
}

export const BlockToolbar: React.FC<BlockToolbarProps> = ({ onAddBlock }) => {
  return (
    <div className="card border-dashed p-3 text-center my-3 bg-body-tertiary">
      <div className="d-flex align-items-center justify-content-center gap-1 flex-wrap">
        <span className="small text-secondary fw-semibold me-2 d-flex align-items-center gap-1">
          <Plus size={16} /> Add Block:
        </span>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('header')}
        >
          <Heading size={14} /> Heading
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('paragraph')}
        >
          <AlignLeft size={14} /> Paragraph
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('image')}
        >
          <ImageIcon size={14} /> Image
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('list')}
        >
          <List size={14} /> List
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('callout')}
        >
          <AlertCircle size={14} /> Callout
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('table')}
        >
          <TableIcon size={14} /> Table
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('columns')}
        >
          <ColumnsIcon size={14} /> Columns
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('code')}
        >
          <Code size={14} /> HTML
        </button>
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          onClick={() => onAddBlock('delimiter')}
        >
          <Minus size={14} /> Divider
        </button>
      </div>
    </div>
  );
};
